import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { QrCheckOutPage } from '@/features/check-ins/qr-checkout-page'

export const Route = createFileRoute('/_authenticated/check-ins/qr-checkout')({
  beforeLoad: requireAdmin,
  component: QrCheckOutPage,
})
